<template>
  <div id="app">
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
export default {
  name: "App",
  components: {}
};
</script>

<style>
* {
  padding: 0;
  margin: 0;
}
html,
body {
  width: 100%;
  height: 100%;
  background-color: #07226b;
}
#app {
  height: 100%;
  width: 100%;
}
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
.el-message {
  font-size: 0.3rem;
}

/* 设置滚动条的样式 */
::-webkit-scrollbar {
  width: 0.03rem;
}
/* 滚动槽 */
::-webkit-scrollbar-track {
  /* border-radius: 0;
  width: 0px;
  background-color: transparent; */
  width: 0.03rem;
  border-radius: 0.03rem;
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  /* border-radius: 0;
  background: transparent; */
  width: 0.03rem;
  background: rgba(0, 160, 233, 0.5);
  border-radius: 0.03rem;
}
</style>



// WEBPACK FOOTER //
// src/App.vue